/* import __COLOCATED_TEMPLATE__ from './stamp.hbs'; */
/* RESPONSIBLE TEAM: team-messenger */

import Component from '@glimmer/component';
export interface StampArgs {
  text: string;
  tooltip?: string;
  color?: string;
}

interface Signature {
  Element: HTMLElement;
  Args: StampArgs;
}

export default class Stamp extends Component<Signature> {
  get color() {
    if (this.args.color === 'green') {
      return 'bg-success-container text-default border-success-border';
    }

    if (this.args.color === 'yellow') {
      return 'bg-notice-container text-default border-notice-border';
    }

    return 'bg-neutral-container text-muted border-neutral-border';
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'InstallationNew::Stamp': typeof Stamp;
    'installation-new/stamp': typeof Stamp;
  }
}
